import { createContext } from "react";
// all users
export const UserInfo = createContext(null);
// customer only
export const CustomerInfo = createContext(null);
// merchant only
export const MerchantInfo = createContext(null);
// proprietor only
export const ProprietorInfo = createContext(null);
